import { Typography } from '@mui/material'
import colors from '../../constants/colors'
import { uploadInputZones } from './types'
import { ReactComponent as TextIcon } from '../../assets/images/TextIcon.svg'
import { ReactComponent as ImageIcon } from '../../assets/images/ImageIcon.svg'
import { ReactComponent as CameraIcon } from '../../assets/images/CameraIcon.svg'
import { ReactComponent as AudioIcon } from '../../assets/images/AudioIcon.svg'
import { ReactComponent as DocumentIcon } from '../../assets/images/DocumentIcon.svg'
import { ReactComponent as LinkIcon } from '../../assets/images/LinkIcon.svg'

const getDropzoneIconsAndText = ({
  type,
  themeColor = colors.TAG_PURPLE,
}: {
  type: string
  themeColor?: string
}) => {
  const dropzoneIconsAndText: { [key: string]: React.ReactNode } = {
    [uploadInputZones.TEXT_FIELD]: (
      <>
        <TextIcon fill={themeColor} />
        <Typography variant='bodyBold' sx={{ color: themeColor }}>
          Text Field
        </Typography>
      </>
    ),
    [uploadInputZones.IMAGE]: (
      <>
        <ImageIcon fill={themeColor} />
        <Typography variant='bodyBold' sx={{ color: themeColor }}>
          Select a Image File to Upload
        </Typography>
      </>
    ),
    [uploadInputZones.VIDEO]: (
      <>
        <CameraIcon fill={themeColor} width={36} height={24} />
        <Typography variant='bodyBold' sx={{ color: themeColor }}>
          Select a Video File to Upload
        </Typography>
      </>
    ),
    [uploadInputZones.AUDIO]: (
      <>
        <AudioIcon fill={themeColor} />
        <Typography variant='bodyBold' sx={{ color: themeColor }}>
          Select a Audio File to Upload
        </Typography>
      </>
    ),
    [uploadInputZones.DOCUMENT]: (
      <>
        <DocumentIcon fill={themeColor} />
        <Typography variant='bodyBold' sx={{ color: themeColor }}>
          Select a Document File to Upload
        </Typography>
      </>
    ),
    [uploadInputZones.LINK]: (
      <>
        <LinkIcon fill={themeColor} />
        <Typography variant='bodyBold' sx={{ color: themeColor }}>
          Select Link
        </Typography>
      </>
    ),
  }

  return dropzoneIconsAndText[type]
}

const dropzoneAcceptanceType: { [key: string]: uploadInputZones } = {
  [uploadInputZones.TEXT_FIELD]: uploadInputZones.TEXT_FIELD,
  [uploadInputZones.IMAGE]: uploadInputZones.IMAGE,
  [uploadInputZones.VIDEO]: uploadInputZones.VIDEO,
  [uploadInputZones.AUDIO]: uploadInputZones.AUDIO,
  [uploadInputZones.DOCUMENT]: uploadInputZones.DOCUMENT,
  [uploadInputZones.LINK]: uploadInputZones.LINK,
}

const acceptanceTypes: { [key: string]: any } = {
  [uploadInputZones.IMAGE]: {
    'image/*': ['.jpeg', '.png', '.svg'],
  },
  [uploadInputZones.VIDEO]: {
    'video/*': ['.mp4', '.MP4'],
  },
  [uploadInputZones.DOCUMENT]: {
    'application/pdf': ['.pdf'],
    'application/msword': ['.doc'],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
    'application/vnd.ms-excel': ['.xls'],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
    'application/vnd.ms-powerpoint': ['.ppt'],
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': ['.pptx'],
    'text/plain': ['.txt'],
    'text/csv': ['.csv'],
    'application/vnd.oasis.opendocument.text': ['.odt'],
  },
  [uploadInputZones.AUDIO]: {
    'audio/*': ['.mp3', '.wav', '.avi', '.aac'],
  },
  [uploadInputZones.ALL]: {},
}

const mainContainerStyle = {
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
}

const dropZoneStyle = {
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  py: '2.5rem',
}

export default {
  getDropzoneIconsAndText,
  dropzoneAcceptanceType,
  mainContainerStyle,
  dropZoneStyle,
  acceptanceTypes,
}
